import React from 'react';

export default props => (
    <div className="custom-control custom-radio">
        <input type="radio"
            className="custom-control-input"
            id={props.id}
            name={props.name}
            checked={props.checked}
            onChange={props.onChange}
            value={props.value}
        />
        <label
            className="custom-control-label"
            htmlFor={props.id}>
            {props.label}
        </label>
    </div>
);